import moment from "moment";
import { useEffect, useRef, useState } from "react";

const useDateTime = () => {
    const [date, setDate] = useState(moment().format('DD MMMM, YYYY'))
    const [time, setTime] = useState(moment().format('HH:mm:ss'))
    const intervalRef = useRef<NodeJS.Timeout>()
    useEffect(() => {
        intervalRef.current = setInterval(() => {
            setDate(moment().format('DD MMMM, YYYY'))
            setTime(moment().format('HH:mm:ss'))
        },1000)
        return () => {
            if (intervalRef.current) clearInterval(intervalRef.current)
        }
    }, [])

    return {
        time,
        date
    }
}

export default useDateTime;
